import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";
export default function WarrantyInquiry() {
  const [query, setQuery] = useState("");
  return <section className="dark">
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@300;400;500;600;700&family=Space+Mono:wght@400;700&display=swap');`}</style>
      <div className="bg-background text-foreground min-h-[420px] flex items-center justify-center relative overflow-hidden px-4 py-20" style={{
      fontFamily: "'Space Grotesk', sans-serif"
    }}>
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute top-0 left-0 w-full h-px bg-border opacity-40" />
          <div className="absolute bottom-0 left-0 w-full h-px bg-border opacity-40" />
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full opacity-10" style={{
          background: "radial-gradient(circle, hsl(var(--primary)) 0%, transparent 70%)"
        }} />
          <div className="absolute top-4 left-8 w-px h-24 bg-primary opacity-20" />
          <div className="absolute bottom-4 right-8 w-px h-24 bg-primary opacity-20" />
          <div className="absolute top-4 left-8 w-24 h-px bg-primary opacity-20" />
          <div className="absolute bottom-4 right-8 w-24 h-px bg-primary opacity-20" />
        </div>

        <div className="relative z-10 w-full max-w-2xl flex flex-col items-start gap-8">
          <div className="flex flex-col gap-2">
            <span className="text-xs tracking-[0.35em] uppercase text-primary font-medium" style={{
            fontFamily: "'Space Mono', monospace"
          }}>
              — Service Portal
            </span>
            <h2 className="text-5xl md:text-6xl font-bold text-foreground leading-none tracking-tight" style={{
            letterSpacing: "-0.02em"
          }}>
              WARRANTY
              <br />
              <span className="text-primary">INQUIRY</span>
            </h2>
          </div>

          <div className="w-full flex flex-col sm:flex-row items-stretch gap-0 border border-border rounded-none overflow-hidden">
            <div className="flex items-center flex-1 bg-card px-4 gap-3">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1696675/img/icon-search3.png" className="w-full h-auto max-w-[28px] opacity-60 flex-shrink-0" />
              <Input value={query} onChange={e => setQuery(e.target.value)} placeholder="Warranty inquiry" className="border-0 bg-transparent text-foreground placeholder:text-muted-foreground focus-visible:ring-0 focus-visible:ring-offset-0 text-base px-0 py-5 h-auto rounded-none" style={{
              fontFamily: "'Space Grotesk', sans-serif"
            }} />
            </div>
            <Button className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-none px-8 py-5 h-auto text-sm font-semibold tracking-widest uppercase transition-all duration-200" style={{
            fontFamily: "'Space Mono', monospace"
          }}>
              Search
            </Button>
          </div>

          <div className="flex items-center gap-6 mt-2">
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 rounded-full bg-primary animate-pulse" />
              <span className="text-xs text-muted-foreground tracking-wide" style={{
              fontFamily: "'Space Mono', monospace"
            }}>
                Live Database
              </span>
            </div>
            <div className="w-px h-4 bg-border" />
            <span className="text-xs text-muted-foreground tracking-wide" style={{
            fontFamily: "'Space Mono', monospace"
          }}>
              Enter serial or order number
            </span>
          </div>
        </div>
      </div>
    </section>;
}